import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { makeGetRequest } from "../../services/httpHelper";

export default function WaitingMpesa() {
  const { state } = useLocation();
  const navigate  = useNavigate();
  const { orderId, amount } = state;

  const [status, setStatus] = useState("awaiting_payment");

  
      const pollPaymentStatus = () => {
  const iv = setInterval(async () => {
    const res = await makeGetRequest(
      `payments/polling/${orderId}/status`
    );

    console.log('order status',res.data);           // <- keep for debugging
    setStatus(res.data.status);

    if (res.data.status === 'fulfilled') {
      clearInterval(iv);
      navigate('/payment-success',   { state: { order: res.data.order } });
    } else if (res.data.status === 'cancelled') {
      clearInterval(iv);
      navigate('/payment-cancelled', { state: { order: res.data.order } });
    } else if (res.data.status === 'failed') {
      clearInterval(iv);
      navigate('/payment-failure',   { state: { order: res.data.order } });
    }
    // else keep polling while status === 'awaiting_payment' (or whatever)
  }, 4000);

  return () => clearInterval(iv);    // cleanup on unmount
};


  useEffect(() => {
   pollPaymentStatus();
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: 120 }}>
      <h2>Waiting for MPESA Confirmation</h2>
      <p>Amount: KES {amount}</p>
      <p>Status: {status}</p>
    </div>
  );
}
